import { isNil } from "ramda";
import { getAttributeValue } from "@/utils";

export function decorateShoppingCartItem(item) {
  item.unitNetPriceDisplay = isNil(item.unitNetPrice)
    ? "Market Price"
    : `$${item.unitNetPrice.toFixed(2)}`;
  item.totalGrossPriceDisplay = item.totalGrossPrice.toFixed(2);
  item.isPackage = getAttributeValue(item.attributes, "isPackage");
  item.packageOptions = getAttributeValue(
    item.attributes,
    "packageOptions"
  ); // options available
  item.packageSelections = getAttributeValue(
    item.attributes,
    "packageSelections"
  ); // options selected
  item.isSpecificationEnabled = getAttributeValue(item.attributes, "isSpecificationEnabled");
  item.specificationOptions = getAttributeValue(item.attributes, "specificationOptions", [])
    .map(specOption => ({ ...specOption, unitNetPriceDisplay: Number(specOption.unitNetPrice).toFixed(2) })); // options available
  item.specificationSelectionIndex = getAttributeValue(item.attributes, "specificationSelectionIndex");
  item.specificationSelection = getAttributeValue(item.attributes, "specificationSelection", {}); // option selected
  item.isEventProduct = getAttributeValue(item.attributes, "isEventProduct");
  item.isDetailPageEnabled = getAttributeValue(item.attributes, "isDetailPageEnabled");
}